import Loading from "components/ui/Loading";
import Timeline from "components/ui/Timeline";
import { getDashboard, getUsersProfile } from "store/api/apiSlice";
import { getPartnerConfig } from "utils/partner";
import { getEvents } from "./utils";

const PaydayTimeline = () => {
  const partner = getPartnerConfig();
  const { data: dashboard, isLoading: isLoadingDashboard } = getDashboard();
  const { data: userProfile, isLoading: isLoadingUserProfile } =
    getUsersProfile();

  if (isLoadingDashboard || isLoadingUserProfile) return <Loading />;

  const events = getEvents({ dashboard, userProfile, partner });

  return <Timeline events={events} />;
};

export default PaydayTimeline;
